import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { DataGroupIdmUsersTable } from "../index";

export const DataGroupIdmUserTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    // eslint-disable-next-line no-underscore-dangle
    const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";
    return !isMSEntraLogin ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <DataGroupIdmUsersTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    ) : (
        <>
            {" "}
            <div> </div>
        </>
    );
};
